module.exports = __webpack_public_path__ + "static/hero-e785f077f4c7005e6dd7331641640e9c.svg";